// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../rescript/lib/es6/array.js";
import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as React from "@sentry/react";
import * as Logger$Catalyst from "../logger/Logger.bs.js";
import * as Exception$Catalyst from "./types/Exception.bs.js";
import * as ExnHandler$Catalyst from "./ExnHandler.bs.js";
import * as ResponseHandler$Catalyst from "./ResponseHandler.bs.js";

function promiseWithTimeout(promise, timeoutMs) {
  var timeoutPromise = new Promise((function (param, reject) {
          setTimeout((function (param) {
                  return reject({
                              RE_EXN_ID: Exception$Catalyst.RequestTimedout
                            });
                }), timeoutMs);
          
        }));
  return Promise.race($$Array.of_list({
                  hd: promise,
                  tl: {
                    hd: timeoutPromise,
                    tl: /* [] */0
                  }
                }));
}

function promiseWithTimeoutAndRetry(promiseGenerator, timeoutMs, retryCount) {
  var finalPromise = promiseWithTimeout(Curry._1(promiseGenerator, undefined), timeoutMs);
  return finalPromise.catch(function (error) {
              var match = ExnHandler$Catalyst.ExnHandler.mapErrorToExn(error);
              if (match.RE_EXN_ID === Exception$Catalyst.RequestTimedout && retryCount > 0) {
                return promiseWithTimeoutAndRetry(promiseGenerator, timeoutMs, retryCount - 1 | 0);
              } else {
                return finalPromise;
              }
            });
}

function resolveResponse(promise, requestUrl) {
  return promise.then(ResponseHandler$Catalyst.ResponseWrapper.execute).catch(function (error) {
              Logger$Catalyst.error("----error-logging-Promise-Handler-catch---");
              Logger$Catalyst.error(error);
              React.captureException(error, {
                    tags: {
                      type: "API_ERROR"
                    },
                    contexts: {
                      request: {
                        API_URL: requestUrl
                      }
                    }
                  });
              var exp = ExnHandler$Catalyst.ExnHandler.mapErrorToExn(error);
              if (exp.RE_EXN_ID === Exception$Catalyst.RequestTimedout) {
                return Promise.resolve(/* RequestTimeout */0);
              } else if (exp.RE_EXN_ID === Exception$Catalyst.FailedToFetch) {
                return Promise.resolve(/* FailedToFetch */1);
              } else if (exp.RE_EXN_ID === Exception$Catalyst.RequestCancelled) {
                return Promise.resolve(/* RequestCancelled */2);
              } else if (exp.RE_EXN_ID === Exception$Catalyst.OperationAborted) {
                return Promise.resolve(/* OperationAborted */3);
              } else if (exp.RE_EXN_ID === Exception$Catalyst.Cors) {
                return Promise.resolve({
                            TAG: /* Cors */8,
                            _0: exp._1
                          });
              } else if (exp.RE_EXN_ID === Exception$Catalyst.UnhandledError) {
                return Promise.resolve({
                            TAG: /* UnhandledError */9,
                            _0: exp._1
                          });
              } else {
                return Promise.resolve({
                            TAG: /* UnhandledError */9,
                            _0: error
                          });
              }
            });
}

function resolvePromise(promise, timeoutMs, requestUrl) {
  return resolveResponse(promiseWithTimeout(promise, timeoutMs), requestUrl);
}

function resolvePromiseWithRetry(promiseGenerator, timeoutMs, retryCount, requestUrl) {
  return resolveResponse(promiseWithTimeoutAndRetry(promiseGenerator, timeoutMs, retryCount), requestUrl);
}

var PromiseHandler = {
  resolvePromise: resolvePromise,
  resolvePromiseWithRetry: resolvePromiseWithRetry
};

export {
  PromiseHandler ,
  
}
/* @sentry/react Not a pure module */
